import React, { ReactNode, useEffect, useState } from "react";
import {
  PlayerAvatar,
  PlayerCardData,
  PlayerClubCountryInfoData,
  PlayerClubInfoData,
  PlayerLargeDataText,
  PlayerLargeDataValue,
  PlayerSmallData,
  PlayerSmallDataText,
} from "../styled-components/PlayerCard.Styles";
import { IPlayerCardData, IPlayersOtherInformation } from "../types/IPlayerDetail";
import ChipComponent from "../ui/Chip";
import LabelNumber from "../styled-components/LabelNumber";
import LabelText from "../ui/LabelText";
import styled from "styled-components";
import HeaderTextWithIcon from "./PlayerDetail/HeaderTextWithIcon";
import SecondaryButton from "../ui/SecondaryButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IApiResponse from "../types/IApiResponse";
import { postData } from "../services/api";
import handleApiResponse from "../utils/handleApiResponse";
import apiUrls, { BASE_URL } from "../config/apiUrls";
import { useLocation, useNavigate } from "react-router-dom";
import { useSearch } from "../contexts/PlayerSearchContext";
import { IPlayerSearchResponse, IPlayerZonePosition } from "../types/IPlayerSearchResponse";
import { useNotification } from "../contexts/NotificationContext";
import EuroIcon from "@mui/icons-material/Euro";
import CustomizedTooltips from "../ui/Tooltip";
import Pitch from "./Pitch";
import { ChemistryPlayerPositions, TeamChemistry } from "../types/IOption";
import { ModuleSpinner } from "../ui/LoadingSpinner/ModuleSpinner";
import VisibleON from "../assets/icons/VisibleON.png";
import { ArchetypeInfoDrawer, FullModuleFitView } from "../pages/Chemistry/UIContent";
import { useTheme } from "../contexts/ThemeContext";
import { EmptyData } from "./PlayerDetail/Attributes/Tags";
import ModuleFitLargePitch from "./ModuleFitLargePitch";
import { useLoading } from "../contexts/LoadingContext";
import { fetchPlayerZonePositionData } from "../services/dataService";
import { usePlayerSearch } from "../contexts/SearchPlayersContext";
import { IPlayerAttributesData } from "../types/IPlayerAttributesData";
import { attributeSections } from "../data/attributeSection";
import noImageClub from "../assets/icons/noImageClub.svg";
import Switch from "../ui/CustomSwitch";
import { useAuth } from "../contexts/AuthContext";
import { addUpdateSortListData } from "./PlayerComparison/addOrUpdateSortList";
import PWNotification from "./PWNotification";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { useNewPlayerShortlistContext } from "../contexts/NewPlayerShortlistContext";
import InfoIcon from "../assets/icons/infoicon.svg";

interface Props {
  playerData: IPlayerCardData;
  isOpen: boolean;
  onToggle: () => void;
  replacingPlayerID?: number;
  club?: number;
  replacingPlayerClubImg?: string;
}
export interface ISimilarChemistry {
  newPlayerChemistry: {
    formationName: string;
    positionResults: ChemistryPlayerPositions[];
    teamChemstriys: TeamChemistry[];
  };
  newSystemFit: number;
  oldPlayerChemistry: {
    formationName: string;
    positionResults: ChemistryPlayerPositions[];
    teamChemstriys: TeamChemistry[];
  };
  oldSystemFit: number;
}

const StyledTags = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  width: 100%;
  height: 100%;
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

export const PlayerTagsData = styled.div<{ background: string }>`
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  background: ${({ background }) => background}; //var(--Shades-Brand-Green-2-green-2-200, #ACF8C0);
  font-family: DM Mono;
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;

  & .player-data-text {
    color: #111111;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    /* DM-Mono/Label/Small */
    font-family: "DM Mono";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 100% */
    text-transform: uppercase;
  }
`;

const StyledIcon = styled.div`
  margin-left: 10px;
  padding-left: 8px;
  border-left: 2px solid ${({ theme }) => theme.playerDataBorder};
  height: 40px;
  align-content: center;
`;

export const FullViewBtn = styled.div`
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.timeline};
  width: 27px;
  height: 27px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.selectedListBackground};
  & img {
    width: 23px;
    height: 23px;
    filter: ${({ theme }) => (theme.mode === "light" ? "none" : "grayscale(100%) brightness(0) invert(1)")};
    cursor: pointer;
  }
`;

export const BothPlayerImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  margin-top: -60px;
  & .image-container {
    background-color: ${({ theme }) => theme.selectedListBackground};
    padding: 4px;
    border: 1px solid ${({ theme }) => theme.playerCardBorderColor};
    border-radius: 99px;
    display: flex;
    gap: 16px;
  }
`;

export const PlayerImageContainer = styled.div<{ isSelected: boolean }>`
  border: 4px solid ${({ isSelected }) => (isSelected ? "#00D1A8" : "none")};
  box-sizing: border-box;
  background-color: #d9d9d9;
  border-radius: 100%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  z-index: 1;
  & img {
    width: 58px;
    height: 58px;
    margin-bottom: -5px;
  }
`;

export const PartnershipScoreContainer = styled.div<{ club?: number | undefined }>`
  width: 100%;
  font-family: DM Mono;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  padding-top: 12px;
  border-top: ${({ club }) => (club ? "1px solid #DADADA" : 0)};
  color: ${({ theme }) => theme.NumberColor};
  & p:first-child {
    margin-block-end: 0;
  }
  & p {
    margin-block-start: 0px;
  }
  & span {
    font-size: 16px;
    color: ${({ theme }) => theme.playerColor};
    padding-left: 2px;
  }
`;

const ModuleChemHeader = styled.p`
  color: ${({ theme }) => theme.playerColor};
`;

const PlayerInfo: React.FC<Props> = ({ playerData, isOpen, onToggle, replacingPlayerID, club, replacingPlayerClubImg }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { startLoading, stopLoading } = useLoading();
  const {
    handleSelectedPlayerZones,
    handleSelectedProfiles,
    setAllProfiles,
    setPlayerSearchResultsVisible,
    setOriginPage,
    handleSelectedPlayer,
    isAllPosition,
    handleSelectedAttributes,
    setIsSearchByAttributes,
    setIsPlayerFilterChange,
    setIsAltered,
    originPage,
    reset,
  } = usePlayerSearch();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { userData } = useAuth();
  const {
    showNotification,
    hideNotification,
    displayNotification,
    setDisplayNotification,
    notificationContent,
    setNotificationContent,
    setShouldHideAfterTimeout,
  } = useNotification();
  const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
  const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);
  const { handleSelectedPlayers, originsPage, handleOriginPage } = useSearch();
  const [playerOtherInfo, setPlayersOtherInfo] = useState<IPlayersOtherInformation>();
  const [positionResults, setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [teamChemistry, setTeamChemistry] = useState<TeamChemistry[]>([]);
  const [oldPositionResults, setOldPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [oldTeamChemistry, setOldTeamChemistry] = useState<TeamChemistry[]>([]);
  const [isHover, setIsHover] = useState<boolean>(false);
  const [isFullViewOpen, setIsFullViewOpen] = useState<boolean>(false);
  const [oldPlayer, setOldPlayer] = useState<ChemistryPlayerPositions>();
  const [newPlayer, setNewPlayer] = useState<ChemistryPlayerPositions>();
  const [currentPlayerView, setCurrentPlayerView] = useState<number>(replacingPlayerID ? replacingPlayerID : 0);
  const [oldSystemFit, setOldSystemFit] = useState<number>(0);
  const [newSystemFit, setNewSystemFit] = useState<number>(0);
  const [toggleAddSimilarButton, setIsToggleAddSimilarButton] = useState<boolean>();
  const [addedPlayerShortList, setAddedPlayerShortList] = useState<boolean>(false);
  const {newlyAddedPlayerCount, setNewlyAddedPlayerCount} = useNewPlayerShortlistContext();

  useEffect(() => {
    const fetchOtherInformationOfPlayer = async () => {
      if (isOpen) {
        const requestParameters = {
          playerId: playerData.playerId,
        };
        const response: IApiResponse<IPlayersOtherInformation> = await postData(apiUrls.PlayerExtraDetails, requestParameters);
        handleApiResponse(
          response,
          (playersOtherInformation) => {
            setPlayersOtherInfo(playersOtherInformation);
          },
          (error) => {
            console.error("Error fetching players other information:", error);
          }
        );
      }
    };
    fetchOtherInformationOfPlayer();
  }, [isOpen]);

  const handleChipClick = () => {
    //console.log("you clicked chip");
  };

  const fetchPlayerZonePosition = async (playerId: number) => {
    startLoading();
    try {
      const response: IApiResponse<IPlayerZonePosition> = await fetchPlayerZonePositionData(playerId);
      if (response.isSuccess) {
        const playerZonePositionData = response.data;
        handleSelectedPlayerZones(playerZonePositionData?.zones || []);
        const allPositionList = playerZonePositionData?.position?.playerPositions || [];
        setAllProfiles(allPositionList);
        const selectedProfileItems = playerZonePositionData?.position?.selectedPosition || [];
        const filteredPositions = allPositionList.filter((position) => selectedProfileItems.includes(position.positionId));
        const positionIdsArray: number[] = filteredPositions.map((position) => position.positionId);
        handleSelectedProfiles(positionIdsArray || []);
      } else {
        console.error(response.error?.message || "Error fetching player zone position data");
      }
    } finally {
      stopLoading();
    }
  };

  const fetchAttributesData = async (playerId: number) => {
    startLoading();
    try {
      const requestParameters = {
        userId: 0,
        playerId: playerId,
        AllPosition: isAllPosition === "allpositions",
        AttributeScoreFor: "universe",
        seasonId: 0,
      };
      const response: IApiResponse<IPlayerAttributesData> = await postData(apiUrls.GetPlayerAttributes, requestParameters);
      if (response.isSuccess) {
        const attributesData = response.data;
        const playerAttributesUniverse = attributesData.playerAttributesUniverseTheirPos;
        const updatedSections = attributeSections.map((section) => ({
          ...section,
          attributes: section.attributes.map((attribute) => {
            let score: number | null = null;
            // Determine the score based on the attribute ID
            switch (attribute.id) {
              case "Height Cm":
                score = attributesData.heightInCM;
                break;
              case "Av. contribution score":
                score = playerAttributesUniverse.overall.performanceValue;
                break;
              case "finishing-shots":
                score = playerAttributesUniverse.finalThird.finishingShots.score;
                break;
              case "finishing-aerial":
                score = playerAttributesUniverse.finalThird.finishingAerial.score;
                break;
              case "attack-positioning":
                score = playerAttributesUniverse.finalThird.attackPositioning.score;
                break;
              case "creativity":
                score = playerAttributesUniverse.buildUpPlay.creativity.score;
                break;
              case "passing-accuracy":
                score = playerAttributesUniverse.buildUpPlay.passingAccuracy.score;
                break;
              case "dribbling":
                score = playerAttributesUniverse.buildUpPlay.dribbling.score;
                break;
              case "crossing":
                score = playerAttributesUniverse.buildUpPlay.crossing.score;
                break;
              case "tackling":
                score = playerAttributesUniverse.defence.tackling.score;
                break;
              case "defensive-headers":
                score = playerAttributesUniverse.defence.defensiveHeaders.score;
                break;
              case "aggression":
                score = playerAttributesUniverse.defence.aggression.score;
                break;
              default:
                return attribute; // If no match, return the original attribute
            }
            // Return the updated attribute with the checked property based on score
            return {
              ...attribute,
              checked: score !== null && score !== 0, // Set checked to true only if score is not null and not 0
              percentile: score,
            };
          }),
        }));
        const selectedAttributelist = updatedSections.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
        handleSelectedAttributes(selectedAttributelist);
        setIsSearchByAttributes(selectedAttributelist.length > 0 ? true : false);
      }
    } finally {
      stopLoading(); // Stop loading regardless of success or failure
    }
  };

  const handleSimilarPlayer = async () => {
    if (originPage === "Similarplayers Tab") {
      reset();
      window.open(`${BASE_URL}/player/${playerData?.playerId}?tab=SimilarPlayers`, "_blank");
      setOriginPage("Similarplayers Tab");
    } else {
      const selectedPlayer: IPlayerSearchResponse = {
        playerName: playerData.playerLabel,
        playerClub: playerData.clubName,
        playerClubURL: playerData.clubImageURL,
        playerId: playerData.playerId,
        playerImageURL: playerData.playerImageURL,
        isEasternPlayer: playerData.isEasternPlayer,
        givenName: playerData.givenName,
        familyName: playerData.familyname,
      };
      handleSelectedPlayers([selectedPlayer]);
      handleSelectedPlayer([selectedPlayer]);
      setIsAltered(false);
      await fetchPlayerZonePosition(playerData.playerId);
      await fetchAttributesData(playerData.playerId);
      setPlayerSearchResultsVisible(true);
      setIsPlayerFilterChange(true);
      handleOriginPage("Search For Similar");
    }
  };

  const handleClubClick = () => {
    if (playerData?.clubName) {
      window.location.href = `${BASE_URL}/club/${playerData?.clubId}`;
    }
  };

  const handleChemistryPlayerChange = () => {
    if (currentPlayerView === newPlayer?.playerId!) {
      setCurrentPlayerView(oldPlayer?.playerId!);
    } else {
      setCurrentPlayerView(newPlayer?.playerId!);
    }
  };

  useEffect(() => {
    if (isOpen && positionResults && positionResults.length === 0) {
      const fetchSystemFitData = async () => {
        setIsLoading(true);
        try {
          const ApiRequestData = {
            selectedPlayerId: replacingPlayerID ?? 0,
            similarPlayerId: playerData.playerId,
            teamId: club ? club : playerData.clubId,
          };
          const response: IApiResponse<ISimilarChemistry> = await postData(apiUrls.PlayerSystemFit, ApiRequestData);
          handleApiResponse(
            response,
            (candidatePlayerChemistry) => {
              setOldPlayer(
                candidatePlayerChemistry.oldPlayerChemistry.positionResults.find((player) => player.playerId === replacingPlayerID)
              );
              setNewPlayer(
                candidatePlayerChemistry.newPlayerChemistry.positionResults.find((player) => player.playerId === playerData.playerId)
              );
              setOldPositionResults(candidatePlayerChemistry.oldPlayerChemistry.positionResults);
              setPositionResults(candidatePlayerChemistry.newPlayerChemistry.positionResults);
              setOldTeamChemistry(
                candidatePlayerChemistry.oldPlayerChemistry.teamChemstriys.filter(
                  (player) => player.player1 === replacingPlayerID || player.player2 === replacingPlayerID
                )
              );
              setTeamChemistry(
                candidatePlayerChemistry.newPlayerChemistry.teamChemstriys.filter(
                  (player) => player.player1 === playerData.playerId || player.player2 === playerData.playerId
                )
              );
              setOldSystemFit(candidatePlayerChemistry.oldSystemFit);
              setNewSystemFit(candidatePlayerChemistry.newSystemFit);
            },
            (error) => {
              console.error(error);
            }
          );
        } catch (error) {
          console.error("Error fetching player card data:", error);
        }
        setIsLoading(false);
      };
      fetchSystemFitData();
    }
  }, [isOpen]);

  const handleNameClick = () => {
    window.location.href = `${BASE_URL}/player/${playerData?.playerId}`;
  };

  useEffect(() => {
    setIsToggleAddSimilarButton(playerData?.isPlayerInShortlist!);
  }, [playerData]);

  const handleAddPlayer = () => {
    setIsToggleAddSimilarButton(!toggleAddSimilarButton);
    if (toggleAddSimilarButton) {
      setAddedPlayerShortList(false);
      addUpdateSortListData(
        userData,
        [playerData?.playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        true,
        navigate
      );
    } else {
      setNewlyAddedPlayerCount((prev) => prev + 1);
      setAddedPlayerShortList(true);
      addUpdateSortListData(
        userData,
        [playerData?.playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );
    }
  };

  const handleActions = () => {
    setIsToggleAddSimilarButton(!toggleAddSimilarButton);
    if (!addedPlayerShortList) {
      addUpdateSortListData(
        userData,
        [playerData?.playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );
    }
  };

  useEffect(() => {
    setCustomNotificationContent(
      <div className="notification">
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">
            {addedPlayerShortList ? "Player added to your shortlist " : "Player removed from your shortlist"}
          </LabelText>
          {!addedPlayerShortList ? (
                <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
                  Undo
                </LabelText>
              ) : (
                <LabelText
                  className="player-given-name notification-content"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/shortlists")}
                >
                  View shortlist
                </LabelText>
              )}
        </p>
      </div>
    );
  }, [addedPlayerShortList]);

  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  //console.log(currentPlayerView, newPlayer?.playerId)

  return (
    <>
      <PlayerCardData>
        <div className="player-image-content">
          <div className="player-header">
            <div className="player-chip">
              {playerData?.isInjured && <ChipComponent status={"INJURED"} onClick={handleChipClick} />}
              {playerData?.onLoan && <ChipComponent status={"ON LOAN"} />}
              {playerData?.givenOnLoan && <ChipComponent status={"LOANED OUT"} />}
              {playerData?.isRetired && <ChipComponent status={"RETIRED"} />}
            </div>
            <PlayerAvatar
              className="player-avatar"
              style={{ cursor: "pointer" }}
              backgroundImage={playerData?.playerImageURL || ""}
              onClick={() => {
                hideNotification();
                navigate(`/player/${playerData?.playerId}`);
              }}
            ></PlayerAvatar>
          </div>
          <div className="player-detail-wrapper">
            <div className="player-name-header">
              <div className="player-name-squad">
                <div className="player-fullname" onClick={handleNameClick}>
                  {playerData?.playerLabel?.split(" ")?.length! > 2 ? (
                    <>
                      <LabelText className="three-named-similar-player">{playerData?.playerLabel}</LabelText>
                    </>
                  ) : (
                    <>
                      <LabelText className={playerData?.isEasternPlayer ? "player-family-name" : "player-given-name"}>
                        {playerData?.isEasternPlayer ? playerData?.playerLabel?.split(" ")[1] : playerData?.playerLabel?.split(" ")[0]}
                      </LabelText>
                      <LabelText
                        className={playerData?.isEasternPlayer ? "player-given-name" : "player-family-name"}
                        style={{ fontSize: "32px" }}
                      >
                        {playerData?.isEasternPlayer ? playerData?.playerLabel?.split(" ")[0] : playerData?.playerLabel?.split(" ")[1]}
                      </LabelText>
                    </>
                  )}
                </div>
              </div>
              <div className="actions-btn">
                <SecondaryButton label={isOpen && "Search for similar"} iconType="add" onClick={handleSimilarPlayer} />
                <SecondaryButton
                  label={isOpen && (toggleAddSimilarButton ? "Added to shortlist" : "Add to shortlist")}
                  iconType="bookmark"
                  onClick={() => handleAddPlayer()}
                  isSelected={toggleAddSimilarButton || addedPlayerShortList}
                />

                <StyledIcon>
                  {isOpen ? (
                    <KeyboardArrowUpIcon sx={{ fontSize: "24px" }} onClick={onToggle} />
                  ) : (
                    <KeyboardArrowDownIcon sx={{ fontSize: "24px" }} onClick={onToggle} />
                  )}
                </StyledIcon>
              </div>
            </div>
            <div className="player-small-data-details">
              {playerData?.positionTag?.map((tag, index) => (
                <PlayerSmallData key={index}>
                  <PlayerSmallDataText className="descriptive-text">{tag}</PlayerSmallDataText>
                </PlayerSmallData>
              ))}
              {playerData?.archetypes && 
                <PlayerSmallData>
                  <PlayerSmallDataText className="descriptive-text">{playerData?.archetypes?.[0]?.archetypeName}
                    <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon-similar" onClick={() => setSidebarOpen(true)} />
                  </PlayerSmallDataText>
                </PlayerSmallData>
              }
              {!playerData?.isGoalKeeper && (
                <PlayerSmallData>
                  <PlayerSmallDataText className="descriptive-text">{playerData?.footTag || ""}</PlayerSmallDataText>
                </PlayerSmallData>
              )}
              <PlayerSmallData>
                <PlayerSmallDataText className="descriptive-text">AGE: {playerData?.age || ""}</PlayerSmallDataText>
              </PlayerSmallData>
              <PlayerSmallData>
                <PlayerSmallDataText className="descriptive-text">HEIGHT: {playerData?.heightInCM || ""}cm</PlayerSmallDataText>
              </PlayerSmallData>
              {playerData?.isGoalKeeper && (
                <PlayerSmallData>
                  <PlayerSmallDataText className="descriptive-text">REACH: {playerData?.reach || ""}cm</PlayerSmallDataText>
                </PlayerSmallData>
              )}
            </div>
          </div>
        </div>
        <div className="player-large-data-details">
          {(playerData?.onLoan || playerData?.givenOnLoan || playerData?.loanClubId! > 0) && (
            <>
              <CustomizedTooltips title={"On loan from : " + playerData.clubName}>
                <PlayerClubCountryInfoData
                  className="on-loan resuls-club-data"
                  onClick={() => {
                    window.location.href = `${BASE_URL}/club/${playerData?.clubId}`;
                  }}
                >
                  <img src={playerData?.clubImageURL ? playerData?.clubImageURL : noImageClub} alt="ClubImageURL" />
                </PlayerClubCountryInfoData>
              </CustomizedTooltips>
            </>
          )}
          {(playerData?.onLoan || playerData?.givenOnLoan || playerData?.loanClubId! > 0) && (
            <PlayerClubCountryInfoData
              className="resuls-club-data"
              onClick={() => {
                window.location.href = `${BASE_URL}/club/${playerData?.loanClubId}`;
              }}
            >
              <PlayerClubInfoData country="country" className="player-descriptive-data">
                <PlayerLargeDataText className="descriptive-text">
                  {playerData?.givenOnLoan ? "LOANED OUT" : "ON LOAN"} - {playerData?.loanedTillMonthYear}
                </PlayerLargeDataText>
                <PlayerLargeDataValue className="descriptive-value">{playerData?.loanClubName || ""}</PlayerLargeDataValue>
              </PlayerClubInfoData>
              <img src={playerData?.loanClubImageURL || ""} alt="loanClubImageURL" className="club-image" />
            </PlayerClubCountryInfoData>
          )}
          {!(playerData?.onLoan || playerData?.givenOnLoan || playerData?.loanClubId! > 0) && (
            <PlayerClubCountryInfoData className="resuls-club-data" onClick={handleClubClick}>
              <PlayerClubInfoData country="country" className="player-descriptive-data">
                <LabelNumber className="descriptive-large-text">CLUB</LabelNumber>
                {playerData?.clubName  ? (
                  <LabelNumber className="descriptive-large-value">{playerData?.clubName || ""}</LabelNumber>
                ) : (
                  <LabelNumber className="descriptive-large-value">{"No Current Club"}</LabelNumber>
                )}
              </PlayerClubInfoData>
              {playerData?.clubImageURL && <img src={playerData?.clubImageURL || ""} alt="Club" className="club-image" />}
            </PlayerClubCountryInfoData>
          )}
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">transfer value</LabelNumber>
            <div className="transfer-data">
              <EuroIcon sx={{ fontSize: "20px" }} />
              <LabelNumber className="descriptive-large-value">{playerData?.transferValueText || ""}</LabelNumber>
            </div>
          </PlayerClubInfoData>
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">true value</LabelNumber>
            <div className="transfer-data">
              <EuroIcon sx={{ fontSize: "20px" }} />
              <LabelNumber className="descriptive-large-value">{playerData?.trueValueText || ""}</LabelNumber>
            </div>
          </PlayerClubInfoData>
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">wages pw</LabelNumber>
            <div className="transfer-data">
              <EuroIcon sx={{ fontSize: "20px" }} />
              <LabelNumber className="descriptive-large-value">{playerData.wagesPWText}</LabelNumber>
            </div>
          </PlayerClubInfoData>
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">starts / as sub</LabelNumber>
            <div className="transfer-data">
              <LabelNumber className="descriptive-large-value">{playerData?.starts || 0}/{playerData?.appearancesAsSub || 0}</LabelNumber>
            </div>
          </PlayerClubInfoData>
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">mins played</LabelNumber>
            <div className="transfer-data">
              <LabelNumber className="descriptive-large-value">{playerData?.minutesPlayed || 0}</LabelNumber>
            </div>
          </PlayerClubInfoData>
          <PlayerClubInfoData className="player-descriptive-data">
            <LabelNumber className="descriptive-large-text">attack contribution</LabelNumber>
            <div className="transfer-data">
              <LabelNumber className="descriptive-large-value">{playerData?.performanceValue || 0}</LabelNumber>
            </div>
          </PlayerClubInfoData>
        </div>
        {isOpen && (
          <div className="stat-table-container-search-results">
            <div className="stat-table-column">
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">nationality</LabelText>
                <LabelNumber className="stat-row-value">
                  {playerOtherInfo?.nationalityCountry}
                  <LabelText> ({playerOtherInfo?.region})</LabelText>
                </LabelNumber>
              </div>
              {/* Commented as per WI-1189
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">1st team Starts / on As SUb</LabelText>
                <LabelNumber className="stat-row-value">
                  {playerOtherInfo?.firstTeamStarts}/{playerOtherInfo?.onAsSub}
                </LabelNumber>
              </div> */}
              {/* <div className="stat-table-row">
                <LabelText className="selected-zone-name">Injury risk</LabelText>
                <LabelNumber className="stat-row-value">--</LabelNumber>
              </div> */}
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Contracted until</LabelText>
                <LabelNumber className="stat-row-value">{playerOtherInfo?.contractedUntil}</LabelNumber>
              </div>
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Agent</LabelText>
                <LabelNumber className="stat-row-value"> {playerData?.playerAgent !== null ? playerData?.playerAgent : "--"}</LabelNumber>
              </div>
            </div>
            <div className="stat-table-column">
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Final Third</LabelText>
                <LabelNumber className="stat-row-value">{playerOtherInfo?.finalThird}</LabelNumber>
              </div>
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Build Up PLay</LabelText>
                <LabelNumber className="stat-row-value">{playerOtherInfo?.buildUpPLay}</LabelNumber>
              </div>
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Defence</LabelText>
                <LabelNumber className="stat-row-value">{playerOtherInfo?.defence}</LabelNumber>
              </div>
              {/* <div className="stat-table-row">
                <LabelText className="selected-zone-name">Physical</LabelText>
                <LabelNumber className="stat-row-value">--</LabelNumber>
              </div> */}

              {/* Commented as per WI-1189
              <div className="stat-table-row">
                <LabelText className="selected-zone-name">Attack Contribution</LabelText>
                <LabelNumber className="stat-row-value">{playerOtherInfo?.contribution}</LabelNumber>
              </div> */}
            </div>
          </div>
        )}
        {isOpen && (
          <>
            <div className="stat-table-container-search-results">
              <div className="stat-table-column">
                <StyledTags>
                  <div className="player-tags-wrapper">
                    <HeaderTextWithIcon text="Tags" />
                    <div className="tags-centent">
                      {playerOtherInfo?.tags === null && (
                        <EmptyData className="tags-empty-data">
                          <LabelText className="empty-data-text">No tags currently apply to this player</LabelText>
                        </EmptyData>
                      )}
                      {playerOtherInfo?.tags?.map((tag, index) => (
                        <PlayerTagsData key={index} background={tag.isPositive ? "#4AF075" : "#FF7900"}>
                          <span className="player-data-text">{tag.tagName}</span>
                        </PlayerTagsData>
                      ))}
                    </div>
                  </div>
                </StyledTags>
              </div>
              <div className="stat-table-column">
                <StyledTags>
                  <div
                    className="player-tags-wrapper"
                    style={{ display: "flex", flexDirection: "row", position: "relative", justifyContent: "space-between" }}
                  >
                    <div className="system-fit-header">
                      <ModuleChemHeader className="module-chem-header">{club ? "System fit" : "System fit breakdown"}</ModuleChemHeader>
                      {!isLoading && club && (
                        <p className="predicted-switch-module">
                          Predicted
                          <Switch
                            id="chemistry-predict"
                            toggled={currentPlayerView === newPlayer?.playerId}
                            onChange={handleChemistryPlayerChange}
                            source="Filter"
                            isByComparison={false}
                          />
                        </p>
                      )}
                      {
                        <PartnershipScoreContainer club={club}>
                          <p>{currentPlayerView === newPlayer?.playerId! ? "REPLACING" : "AVERAGE KEY"}</p>
                          <div className="partnership-score">
                            <p>{currentPlayerView === newPlayer?.playerId! ? oldPlayer?.shortName : "PARTNERSHIP SCORE"}</p>
                            <span style={{ marginLeft: "15px" }}>
                              {currentPlayerView === newPlayer?.playerId! ? newSystemFit ? newSystemFit : "--" : oldSystemFit ? oldSystemFit : "--"}
                              {currentPlayerView === newPlayer?.playerId! && (
                                <span style={{ color: newSystemFit - oldSystemFit > 0 ? "#00D1A8" : "#FF3864" }}>
                                  {newSystemFit - oldSystemFit > 0 && "+"}
                                  {newSystemFit - oldSystemFit}
                                </span>
                              )}
                            </span>
                          </div>
                        </PartnershipScoreContainer>
                      }
                    </div>
                    <div className="small-module-pitch" onMouseOver={() => 
                      {
                        let posresult= (currentPlayerView === oldPlayer?.playerId && club ? oldPositionResults : positionResults);
                        if(posresult && posresult.length > 0){
                          setIsHover(true);
                        }
                      }
                      } onMouseLeave={() => setIsHover(false)}>
                      <Pitch
                        isPattern={false}
                        positionResults={currentPlayerView === oldPlayer?.playerId && club ? oldPositionResults : positionResults}
                        teamChemistry={currentPlayerView === oldPlayer?.playerId && club ? oldTeamChemistry : teamChemistry}
                        currentView={"moduleChemistry"}
                        modulefitPlayer={currentPlayerView === oldPlayer?.playerId && club ? oldPlayer?.playerId : newPlayer?.playerId}
                      />
                      {isLoading && <ModuleSpinner />}
                      {isHover && (
                        <FullViewBtn onClick={() => setIsFullViewOpen(true)}>
                          <img src={VisibleON} alt="full-view-button" />
                        </FullViewBtn>
                      )}
                    </div>
                  </div>
                </StyledTags>
              </div>
            </div>
            <FullModuleFitView
              header={"System fit breakdown"}
              theme={theme}
              isFullViewOpen={isFullViewOpen}
              setIsFullViewOpen={setIsFullViewOpen}
            >
              <BothPlayerImageContainer>
                {club && (
                  <div className="image-container">
                    <div className="module-chemistry-player-image">
                      <PlayerImageContainer isSelected={currentPlayerView === newPlayer?.playerId}>
                        <img src={newPlayer?.playerImageURL!} alt="" onClick={() => setCurrentPlayerView(newPlayer?.playerId!)} />
                      </PlayerImageContainer>
                      <img src={playerData?.clubImageURL} alt="" className="module-chemistry-club-image" />
                    </div>
                    <div className="module-chemistry-player-image">
                      <PlayerImageContainer isSelected={currentPlayerView === oldPlayer?.playerId}>
                        <img src={oldPlayer?.playerImageURL} alt="" onClick={() => setCurrentPlayerView(oldPlayer?.playerId!)} />
                      </PlayerImageContainer>
                      <img src={replacingPlayerClubImg} alt="" className="module-chemistry-club-image" />
                    </div>
                  </div>
                )}
                <ModuleFitLargePitch
                  positionResults={currentPlayerView === oldPlayer?.playerId && club ? oldPositionResults : positionResults}
                  teamChemistry={currentPlayerView === oldPlayer?.playerId && club ? oldTeamChemistry : teamChemistry}
                  newPlayerID={newPlayer?.playerId}
                  oldPlayerID={oldPlayer?.playerId}
                  isShowClubImg={true}
                  newPlayerClubURL={playerData?.clubImageURL}
                />
              </BothPlayerImageContainer>
            </FullModuleFitView>
          </>
        )}
        {playerData?.archetypes?.[0]?.archetypeName && playerData?.archetypes?.[0]?.id && 
        <ArchetypeInfoDrawer
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          archetypeName={playerData?.archetypes?.[0]?.archetypeName!}
          activeArchetypeID={playerData?.archetypes?.[0]?.id!}
          playerPosition={playerData?.positionTag?.[0]}
        />}
      </PlayerCardData>
      {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
    </>
  );
};

export default PlayerInfo;
